import React from 'react';
import ReportingDonationsAllDonorsPage from '../components/ReportingDonationsAllDonorsPage';

const ReportingDonationsAllDonorsApp = (props) => (
  <ReportingDonationsAllDonorsPage {...props} />
);

export default ReportingDonationsAllDonorsApp;
